export const DEFAULT_TACTIC_API_URL = 'https://union.gettactic.com';
export const DEFAULT_TACTIC_DEFAULT_PROTOCOL = 'https';
export const DEFAULT_TACTIC_DOMAIN_AND_PORT = 'gettactic.com';
export const DEFAULT_EXCLUDE_SENTRY_STATUS_CODES = [401, 403, 404];
export const DEFAULT_TACTIC_AUTH_HEADER = '';
